module.exports = __webpack_public_path__ + "static/img/Frame-119.a56bee5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Frame-119.png
// module id = wyWj
// module chunks = 1